export const STATUS_TONES: Record<string, { bg: string, fg: string, dot: string, ring: string }> = {
  pending: { bg: '#fffbeb', fg: '#92400e', dot: '#f59e0b', ring: '#fbbf24' },
  paid: { bg: '#f0fdf4', fg: '#15803d', dot: '#16a34a', ring: '#86efac' },
  sent: { bg: '#eff6ff', fg: '#1d4ed8', dot: '#3b82f6', ring: '#93c5fd' },
  used: { bg: '#faf5ff', fg: '#7e22ce', dot: '#a855f7', ring: '#d8b4fe' },
  canceled: { bg: '#fef2f2', fg: '#b91c1c', dot: '#dc2626', ring: '#fca5a5' },
}

export const STATUS_LABELS: Record<string, string> = {
  pending: 'Төлбөр хүлээгдэж буй',
  paid: 'Төлбөр баталгаажсан',
  sent: 'Илгээгдсэн',
  used: 'Ашиглагдсан',
  canceled: 'Цуцлагдсан',
}
